import axios from 'axios';

import turf from "turf";

function filterDistanceFrom(item, filter) {
  if (filter) {
    let pointA = turf.point(filter.coordinates);
    let pointB = turf.center(turf.feature(item.geometry));
    let distance = turf.distance(pointA, pointB)
    if (filter.km == ">100") {
      return distance >= 100
    } else {
      return distance <= filter.km
    }
  }
  return true
}

export default function ({ url }) {
  return {
    namespaced: true,
    state: {
      status: 'init',
      features: [],
    },
    getters: {
      loaded: state => state.status == 'loaded',
      getById: state => id => state.features.find(v => v.id == id),
      features: state => state.features,
      filter: state => filter => state.features.filter(item => {
        if (filter.minPowierzch && (item.properties.powierzch - 0) < filter.minPowierzch) {
          return false
        }
        if (filter.maxPowierzch && (item.properties.powierzch - 0) > filter.maxPowierzch) {
          return false
        }
        if (filter.jst) {
          switch (filter.jst.typ_jst) {
            case ('gmina'):
              if (item.properties.gmina_id != filter.jst.id) {
                return false
              }
              break;
            case ('powiat'):
              if (item.properties.powiat_id != filter.jst.id) {
                return false
              }
              break;
            case ('wojewodztwo'):
              if (item.properties.wojewodztwo_id != filter.jst.id) {
                return false
              }
              break;
            default:
              console.error('invalid filter.jst.typ_jst', filter.jst.typ_jst)
          }
        }
        if (!filterDistanceFrom(item, filter.filterDistanceFromPlace)) {
          return false
        }
        if (!filterDistanceFrom(item, filter.filterDistanceFromPoint)) {
          return false
        }
        if (filter.ofertyIds && filter.ofertyIds.indexOf(item.properties.id) == -1) {
          return false
        }
        return true
      })
    },
    mutations: {
      set(state, { status, features }) {
        state.status = status
        state.features = features
      },
      setStatus(state, { status }) {
        state.status = status
      },
    },
    actions: {
      download(ctx) {
        return new Promise((resolve, reject) => {
          ctx.commit('setStatus', { status: 'loading' })
          axios.get(url)
            .then(r => {
              ctx.commit('set', {
                status: 'loaded',
                features: r.data.features,
              })
              resolve(r)
            })
            .catch(e => {
              ctx.commit('setStatus', { status: 'failure' })
              console.error(e)
              reject(e)
            })
        })
      }
    },
  }
}
